// INVITATIONS
export const GET_INVITATIONS = 'GET_INVITATIONS';
export const ADD_INVITATION = 'ADD_INVITATION';
export const UPDATE_INVITATION = 'UPDATE_INVITATION';
export const DELETE_INVITATION = 'DELETE_INVITATION';
export const INVITATIONS_LOADING = 'INVITATIONS_LOADING';
export const GET_INVITATION_FILTER_VALUES = 'GET_INVITATION_FILTER_VALUES';

// USERS
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";

// VISITORS
export const ACCESS_SUCCESS = "ACCESS_SUCCESS";
export const ACCESS_FAIL = "ACCESS_FAIL";

// AUTH
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
export const CLEAR_PASSWORD_MESSAGE = "CLEAR_PASSWORD_MESSAGE";

// IMPERSONATION
export const START_IMPERSONATION = "START_IMPERSONATION";
export const END_IMPERSONATION = "END_IMPERSONATION";

// ERRORS
export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

// PROFILE
export const GET_PROFILE = 'GET_PROFILE';
export const PROFILE_LOADING = 'PROFILE_LOADING';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAIL = 'UPDATE_PROFILE_FAIL';

// User Types
export const GET_USERS = 'GET_USERS';
export const GET_USERS_MINIMAL = 'GET_USERS_MINIMAL';
export const USERS_LOADING = 'USERS_LOADING';
export const UPDATE_USER = 'UPDATE_USER';
export const GET_USER = 'GET_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';
export const DELETE_USER = 'DELETE_USER';

// LESSONS
export const GET_LESSONS = 'GET_LESSONS';
export const GET_LESSONS_LIST = 'GET_LESSONS_LIST';
export const GET_LESSONS_MINIMAL = 'GET_LESSONS_MINIMAL';
export const GET_LESSON = 'GET_LESSON';
export const ADD_LESSON = 'ADD_LESSON';
export const DELETE_LESSON = 'DELETE_LESSON';
export const UPDATE_LESSON = 'UPDATE_LESSON';
export const LESSONS_LOADING = 'LESSONS_LOADING';
export const LESSON_LOADING = 'LESSON_LOADING';
export const CLEAR_CURRENT_LESSON = 'CLEAR_CURRENT_LESSON';
export const SET_LESSONS_PAGE = 'SET_LESSONS_PAGE';

// COURSES
export const GET_COURSES = 'GET_COURSES';
export const GET_COURSES_LIST = 'GET_COURSES_LIST';
export const GET_COURSES_MINIMAL = 'GET_COURSES_MINIMAL';
export const GET_COURSE = 'GET_COURSE';
export const ADD_COURSE = 'ADD_COURSE';
export const DELETE_COURSE = 'DELETE_COURSE';
export const UPDATE_COURSE = 'UPDATE_COURSE';
export const COURSES_LOADING = 'COURSES_LOADING';
export const COURSE_LOADING = 'COURSE_LOADING';
export const CLEAR_CURRENT_COURSE = 'CLEAR_CURRENT_COURSE';
export const SET_COURSES_PAGE = 'SET_COURSES_PAGE';

// PROGRAMS
export const GET_PROGRAMS = 'GET_PROGRAMS';
export const ADD_PROGRAM = 'ADD_PROGRAM';
export const DELETE_PROGRAM = 'DELETE_PROGRAM';
export const UPDATE_PROGRAM = 'UPDATE_PROGRAM';
export const PROGRAMS_LOADING = 'PROGRAMS_LOADING';

// PATHS
export const GET_PATHS = 'GET_PATHS';
export const GET_PATHS_LIST = 'GET_PATHS_LIST';
export const GET_PATHS_MINIMAL = 'GET_PATHS_MINIMAL';
export const GET_PATH = 'GET_PATH';
export const ADD_PATH = 'ADD_PATH';
export const DELETE_PATH = 'DELETE_PATH';
export const UPDATE_PATH = 'UPDATE_PATH';
export const PATHS_LOADING = 'PATHS_LOADING';
export const SET_PATHS_PAGE = 'SET_PATHS_PAGE';
export const CLEAR_CURRENT_PATH = 'CLEAR_CURRENT_PATH';

// QUESTIONS
export const GET_QUESTIONS = 'GET_QUESTIONS';
export const GET_QUESTIONS_LIST = 'GET_QUESTIONS_LIST';
export const GET_QUESTIONS_MINIMAL = 'GET_QUESTIONS_MINIMAL';
export const GET_QUESTION = 'GET_QUESTION';
export const ADD_QUESTION = 'ADD_QUESTION';
export const DELETE_QUESTION = 'DELETE_QUESTION';
export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const QUESTIONS_LOADING = 'QUESTIONS_LOADING';
export const QUESTION_LOADING = 'QUESTION_LOADING';
export const CLEAR_CURRENT_QUESTION = 'CLEAR_CURRENT_QUESTION';
export const SET_QUESTIONS_PAGE = 'SET_QUESTIONS_PAGE';

// GROUPS
export const GET_GROUPS = 'GET_GROUPS';
export const ADD_GROUP = 'ADD_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const GROUPS_LOADING = 'GROUPS_LOADING';

// ONBOARDING
export const GET_ONBOARDING_QUESTIONS = 'GET_ONBOARDING_QUESTIONS';
export const SUBMIT_ONBOARDING_ANSWERS = 'SUBMIT_ONBOARDING_ANSWERS';
export const CHECK_ONBOARDING_STATUS = 'CHECK_ONBOARDING_STATUS';
export const ONBOARDING_LOADING = 'ONBOARDING_LOADING';
export const CLEAR_ONBOARDING = 'CLEAR_ONBOARDING';

// COURSE CONTENT (lazy-loaded on click)
export const COURSE_CONTENT_LOADED = 'COURSE_CONTENT_LOADED';

// PROGRESS & COURSE PROGRESSION
export const START_COURSE_SUCCESS = 'START_COURSE_SUCCESS';
export const NEXT_LESSON_SUCCESS = 'NEXT_LESSON_SUCCESS';
export const NEXT_CONTENT_SUCCESS = 'NEXT_CONTENT_SUCCESS';
export const NEXT_CONTENT_REQUEST = 'NEXT_CONTENT_REQUEST';
export const COURSE_PROGRESSION_ERROR = 'COURSE_PROGRESSION_ERROR';
export const PROGRESS_LOADING = 'PROGRESS_LOADING';
export const PROGRESS_LOADED = 'PROGRESS_LOADED';
export const PROGRESS_NOT_FOUND = 'PROGRESS_NOT_FOUND';
export const RESET_PROGRESS_SUCCESS = 'RESET_PROGRESS_SUCCESS';
export const RESET_PROGRESS_FAIL = 'RESET_PROGRESS_FAIL';
export const CONTENT_COMPLETED = 'CONTENT_COMPLETED';
export const SUBMISSION_FORM_COMPLETED = 'SUBMISSION_FORM_COMPLETED';
export const NAVIGATION_CONTEXT_LOADED = 'NAVIGATION_CONTEXT_LOADED';

// Event Types
export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_LIST = 'GET_EVENTS_LIST';
export const GET_EVENTS_MINIMAL = 'GET_EVENTS_MINIMAL';
export const GET_EVENT = 'GET_EVENT';
export const ADD_EVENT = 'ADD_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const EVENTS_LOADING = 'EVENTS_LOADING';
export const EVENT_LOADING = 'EVENT_LOADING';
export const CLEAR_CURRENT_EVENT = 'CLEAR_CURRENT_EVENT';
export const SET_EVENTS_PAGE = 'SET_EVENTS_PAGE';

// SUBMISSION FORMS
export const GET_SUBMISSION_FORMS = 'GET_SUBMISSION_FORMS';
export const GET_SUBMISSION_FORMS_LIST = 'GET_SUBMISSION_FORMS_LIST';
export const GET_SUBMISSION_FORMS_MINIMAL = 'GET_SUBMISSION_FORMS_MINIMAL';
export const GET_SUBMISSION_FORM = 'GET_SUBMISSION_FORM';
export const ADD_SUBMISSION_FORM = 'ADD_SUBMISSION_FORM';
export const DELETE_SUBMISSION_FORM = 'DELETE_SUBMISSION_FORM';
export const UPDATE_SUBMISSION_FORM = 'UPDATE_SUBMISSION_FORM';
export const SUBMISSION_FORMS_LOADING = 'SUBMISSION_FORMS_LOADING';
export const SUBMISSION_FORM_LOADING = 'SUBMISSION_FORM_LOADING';
export const CLEAR_CURRENT_SUBMISSION_FORM = 'CLEAR_CURRENT_SUBMISSION_FORM';
export const SET_SUBMISSION_FORMS_PAGE = 'SET_SUBMISSION_FORMS_PAGE';

// SUBMISSIONS
export const GET_SUBMISSIONS = 'GET_SUBMISSIONS';
export const GET_SUBMISSION = 'GET_SUBMISSION';
export const ADD_SUBMISSION = 'ADD_SUBMISSION';
export const UPDATE_SUBMISSION = 'UPDATE_SUBMISSION';
export const DELETE_SUBMISSION = 'DELETE_SUBMISSION';
export const REVIEW_SUBMISSION = 'REVIEW_SUBMISSION';
export const SUBMISSIONS_LOADING = 'SUBMISSIONS_LOADING';
export const GET_SUBMISSION_STATS = 'GET_SUBMISSION_STATS';
export const GET_USER_SUBMISSION_STATUS = 'GET_USER_SUBMISSION_STATUS';
export const SET_SUBMISSIONS_PAGE = 'SET_SUBMISSIONS_PAGE';
export const CLEAR_CURRENT_SUBMISSION = 'CLEAR_CURRENT_SUBMISSION';

// TAGS
export const GET_TAGS = 'GET_TAGS';
export const GET_TAGS_LIST = 'GET_TAGS_LIST';
export const GET_TAGS_MINIMAL = 'GET_TAGS_MINIMAL';
export const GET_TAG = 'GET_TAG';
export const ADD_TAG = 'ADD_TAG';
export const DELETE_TAG = 'DELETE_TAG';
export const UPDATE_TAG = 'UPDATE_TAG';
export const TAGS_LOADING = 'TAGS_LOADING';
export const TAG_LOADING = 'TAG_LOADING';
export const CLEAR_CURRENT_TAG = 'CLEAR_CURRENT_TAG';
export const SET_TAGS_PAGE = 'SET_TAGS_PAGE';

// REINFORCEMENTS
export const GET_REINFORCEMENTS = 'GET_REINFORCEMENTS';
export const GET_REINFORCEMENTS_LIST = 'GET_REINFORCEMENTS_LIST';
export const GET_REINFORCEMENTS_MINIMAL = 'GET_REINFORCEMENTS_MINIMAL';
export const GET_REINFORCEMENT = 'GET_REINFORCEMENT';
export const ADD_REINFORCEMENT = 'ADD_REINFORCEMENT';
export const DELETE_REINFORCEMENT = 'DELETE_REINFORCEMENT';
export const UPDATE_REINFORCEMENT = 'UPDATE_REINFORCEMENT';
export const REINFORCEMENTS_LOADING = 'REINFORCEMENTS_LOADING';
export const REINFORCEMENT_LOADING = 'REINFORCEMENT_LOADING';
export const CLEAR_CURRENT_REINFORCEMENT = 'CLEAR_CURRENT_REINFORCEMENT';
export const SET_REINFORCEMENTS_PAGE = 'SET_REINFORCEMENTS_PAGE';

// EXPERIENCE POINTS
export const GET_USER_XP = 'GET_USER_XP';
export const GET_XP_HISTORY = 'GET_XP_HISTORY';
export const GET_XP_LEADERBOARD = 'GET_XP_LEADERBOARD';
export const AWARD_XP = 'AWARD_XP';
export const RESET_USER_XP = 'RESET_USER_XP';
export const XP_LOADING = 'XP_LOADING';

// DATA IMPORT/EXPORT
export const DATA_EXPORT_REQUEST = 'DATA_EXPORT_REQUEST';
export const DATA_EXPORT_SUCCESS = 'DATA_EXPORT_SUCCESS';
export const DATA_EXPORT_FAIL = 'DATA_EXPORT_FAIL';
export const DATA_IMPORT_REQUEST = 'DATA_IMPORT_REQUEST';
export const DATA_IMPORT_SUCCESS = 'DATA_IMPORT_SUCCESS';
export const DATA_IMPORT_FAIL = 'DATA_IMPORT_FAIL';
export const GET_COLLECTIONS_REQUEST = 'GET_COLLECTIONS_REQUEST';
export const GET_COLLECTIONS_SUCCESS = 'GET_COLLECTIONS_SUCCESS';
export const GET_COLLECTIONS_FAIL = 'GET_COLLECTIONS_FAIL';
export const GET_COLLECTION_COUNT_REQUEST = 'GET_COLLECTION_COUNT_REQUEST';
export const GET_COLLECTION_COUNT_SUCCESS = 'GET_COLLECTION_COUNT_SUCCESS';
export const GET_COLLECTION_COUNT_FAIL = 'GET_COLLECTION_COUNT_FAIL';
export const CLEAR_DATA_OPERATIONS = 'CLEAR_DATA_OPERATIONS';

// BADGES
export const GET_BADGES = 'GET_BADGES';
export const GET_BADGE = 'GET_BADGE';
export const ADD_BADGE = 'ADD_BADGE';
export const DELETE_BADGE = 'DELETE_BADGE';
export const UPDATE_BADGE = 'UPDATE_BADGE';
export const BADGES_LOADING = 'BADGES_LOADING';
export const BADGE_LOADING = 'BADGE_LOADING';
export const CLEAR_CURRENT_BADGE = 'CLEAR_CURRENT_BADGE';
export const GET_USER_BADGES = 'GET_USER_BADGES';

// NOTIFICATIONS
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const MARK_ALL_NOTIFICATIONS_READ = 'MARK_ALL_NOTIFICATIONS_READ';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';

// TERMS & CONDITIONS
export const GET_TERMS_CONDITIONS = 'GET_TERMS_CONDITIONS';
export const ADD_TERMS_CONDITION = 'ADD_TERMS_CONDITION';
export const DELETE_TERMS_CONDITION = 'DELETE_TERMS_CONDITION';
export const UPDATE_TERMS_CONDITION = 'UPDATE_TERMS_CONDITION';
export const TERMS_CONDITIONS_LOADING = 'TERMS_CONDITIONS_LOADING';
export const GET_AVAILABLE_PROGRAMS = 'GET_AVAILABLE_PROGRAMS';
export const GET_TERMS_BY_PROGRAM = 'GET_TERMS_BY_PROGRAM';

// REGISTRATION
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAIL = 'VERIFY_EMAIL_FAIL';
export const CLEAR_REGISTRATION_DATA = 'CLEAR_REGISTRATION_DATA';

// MONDAY SYNC
export const MONDAY_CONNECT_SUCCESS = 'MONDAY_CONNECT_SUCCESS';
export const MONDAY_CONNECT_FAIL = 'MONDAY_CONNECT_FAIL';
export const MONDAY_LOADING = 'MONDAY_LOADING';
export const MONDAY_SYNC_START = 'MONDAY_SYNC_START';
export const MONDAY_SYNC_PROGRESS = 'MONDAY_SYNC_PROGRESS';
export const MONDAY_SYNC_COMPLETE = 'MONDAY_SYNC_COMPLETE';
export const MONDAY_SYNC_FAIL = 'MONDAY_SYNC_FAIL';
export const MONDAY_RESET = 'MONDAY_RESET';
